import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import LogoImg from "../Image/Logo_Updated.jpg";
import LoginBg from "../Image/Picture3.jpg";

const Login = () => {
  const [widgetReady, setWidgetReady] = useState(false);

  useEffect(() => {
    const config = {
      css_url: "/app/embeddediframe.css?v=" + Date.now(),
      forgot_password_css_url: "/app/embedded_password_reset.css?v=" + Date.now(),
    };

    let cancelled = false;
    let attempts = 0;

    // Clear any leftover logout marker so subsequent auth attempts work.
    sessionStorage.removeItem("justLoggedOut");
    localStorage.removeItem("justLoggedOut");

    const tryRenderSignIn = () => {
      if (cancelled) return;
      if (
        window.catalyst &&
        window.catalyst.auth &&
        typeof window.catalyst.auth.signIn === "function"
      ) {
        try {
          window.catalyst.auth.signIn("loginDiv", config);
          setWidgetReady(true);
          // Catalyst renders an iframe asynchronously — strip its scrollbars
          // once it appears in the DOM.
          const HIDE_STYLE =
            "display: none !important;" +
            "visibility: hidden !important;" +
            "height: 0 !important;" +
            "margin: 0 !important;" +
            "padding: 0 !important;" +
            "overflow: hidden !important;";

          const enforceHeadingCenter = (doc) => {
            const headings = doc.querySelectorAll(
              ".signin_head, #headtitle, .titlename, .service_name, .rec_head_text, .recoveryhead, " +
              ".signin_container h1, .signin_container h2, .signin_container h3, " +
              ".signin_box h1, .signin_box h2, .signin_box h3"
            );
            headings.forEach((h) => {
              // Hide Catalyst's heading entirely — React overlay already shows "Sign in".
              h.style.cssText = HIDE_STYLE;
            });

            // Catalyst renders the project name (e.g. "JADGroupWebsite") in
            // a sibling element whose class varies across SDK versions. Find
            // any element whose direct text equals the project name and hide
            // it. This is a safety net for classes our CSS doesn't cover.
            const PROJECT_NAME_PATTERNS = [/jadgroupwebsite/i, /jad\s*group/i];
            const candidates = doc.querySelectorAll(
              ".signin_container *, .signin_box *"
            );
            candidates.forEach((el) => {
              if (
                el.tagName === "INPUT" ||
                el.tagName === "BUTTON" ||
                el.tagName === "FORM" ||
                el.children.length > 0
              ) {
                return;
              }
              const txt = (el.textContent || "").trim();
              if (
                txt &&
                txt.length < 60 &&
                PROJECT_NAME_PATTERNS.some((re) => re.test(txt))
              ) {
                el.style.cssText = HIDE_STYLE;
                // Also hide the parent wrapper if it has no other meaningful content.
                const parent = el.parentElement;
                if (
                  parent &&
                  parent.children.length === 1 &&
                  (parent.textContent || "").trim() === txt
                ) {
                  parent.style.cssText = HIDE_STYLE;
                }
              }
            });
          };
          const stripIframeScroll = () => {
            const iframe = document.querySelector("#loginDiv iframe");
            if (iframe) {
              iframe.style.border = "none";
              try {
                const doc = iframe.contentDocument || iframe.contentWindow.document;
                if (doc) {
                  if (!doc.getElementById("jad-centering-fix")) {
                    const style = doc.createElement("style");
                    style.id = "jad-centering-fix";
                    style.textContent = `
                      .signin_head, #headtitle, .titlename, .service_name,
                      .servicename, .rec_head_text, .recoveryhead,
                      .app_name, .appname, .app-name, .appName,
                      .project_name, .projectname, .project-name,
                      .brand_name, .brandname, .brand-name,
                      .signin_brand, .signin_app_name, .signin_appname,
                      .signin_title, .signin_subtitle, .signin_subhead,
                      .portal_name, .portalname, .text16,
                      [class*="service_name"], [class*="servicename"],
                      [class*="app_name"], [class*="appname"],
                      [class*="brand_name"], [class*="brandname"],
                      [class*="project_name"], [class*="projectname"],
                      [class*="portal_name"],
                      .signin_container h1, .signin_container h2, .signin_container h3,
                      .signin_box h1, .signin_box h2, .signin_box h3 {
                        display: none !important;
                        visibility: hidden !important;
                        height: 0 !important;
                        margin: 0 !important;
                        padding: 0 !important;
                        overflow: hidden !important;
                      }
                      .signin_box, .signin_box * { text-indent: 0 !important; }
                    `;
                    doc.head.appendChild(style);
                  }
                  enforceHeadingCenter(doc);
                  // Keep re-centering after Catalyst SDK injects/re-renders inline styles.
                  if (!doc.__jadHeadingObserver) {
                    const observer = new MutationObserver(() => enforceHeadingCenter(doc));
                    observer.observe(doc.body || doc.documentElement, {
                      attributes: true,
                      attributeFilter: ["style", "class"],
                      childList: true,
                      subtree: true,
                    });
                    doc.__jadHeadingObserver = observer;
                  }
                }
              } catch (e) {
                // Cross-origin iframe — JS access blocked
              }
              return true;
            }
            return false;
          };
          let tries = 0;
          const iframeWatch = setInterval(() => {
            if (stripIframeScroll() || ++tries > 30) {
              clearInterval(iframeWatch);
            }
          }, 100);
        } catch (err) {
          console.error("Catalyst signIn render failed", err);
        }
        return;
      }
      if (attempts++ < 50) {
        setTimeout(tryRenderSignIn, 100);
      } else {
        console.error("Catalyst SDK did not load in time");
      }
    };

    tryRenderSignIn();

    return () => {
      cancelled = true;
    };
  }, []);




  return (

            <div className='login_wall' style={{ backgroundImage: `url(${LoginBg})` }}>

                <div className="Div_logo">
            <Link to="/user-Machines">
              <img src={LogoImg} alt="Logo" style={{ cursor: 'pointer' }} />
            </Link>
            </div>
            <div className="Fixed_button">
           <a href="#">Contact us</a>
           </div>
            <div className='Login_div' style={{
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              minHeight: 'calc(100vh - 60px)',
              padding: '20px',
              boxSizing: 'border-box',
            }}>
            <div style={{
              position: 'relative',
              width: '520px',
              maxWidth: '92vw',
              height: '360px',
              maxHeight: '80vh',
            }}>
              <div id='loginDiv' style={{
                width: '100%',
                height: '100%',
              }}>
              </div>
              {widgetReady && (
                <h1 style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  margin: 0,
                  padding: 0,
                  height: '130px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  fontSize: '32px',
                  fontWeight: 700,
                  fontFamily: 'Arial, Helvetica, sans-serif',
                  color: '#000',
                  background: '#fff',
                  zIndex: 10,
                  pointerEvents: 'none',
                  borderTopLeftRadius: '16px',
                  borderTopRightRadius: '16px',
                }}>
                  Sign in
                </h1>
              )}
            </div>
            {!widgetReady && (
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#ffffff',
                fontFamily: 'Open Sans, sans-serif',
                fontSize: '18px',
                fontWeight: 600,
                pointerEvents: 'none',
                textShadow: '0 1px 4px rgba(0,0,0,0.35)',
              }}>
                <div style={{
                  width: '56px',
                  height: '56px',
                  border: '4px solid rgba(255,255,255,0.35)',
                  borderTop: '4px solid #f3cf05',
                  borderRadius: '50%',
                  animation: 'jad-login-spin 1s linear infinite',
                  marginBottom: '18px',
                  boxShadow: '0 4px 18px rgba(0,0,0,0.25)',
                }} />
                Loading sign-in…
                <style>{`@keyframes jad-login-spin { to { transform: rotate(360deg); } }`}</style>
              </div>
            )}
            <div className="homepage" style={{
              marginTop: '20px',
              textAlign: 'center',
              color: '#ffffff',
              fontFamily: 'Open Sans, sans-serif',
              fontSize: '16px',
              textShadow: '0 1px 4px rgba(0,0,0,0.35)',
            }}>
                    Don't have an account?{" "}
                    <Link
                        to="/User-Register"
                        style={{ color: "#0a3d62", textDecoration: "none", backgroundColor: '#f3cf05', fontSize: '16px', padding: '8px 18px', fontWeight: 700, borderRadius: '6px', marginLeft: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.2)' }}>
                        Sign Up
                    </Link>
                </div>
            </div>
              </div>
  );
};

export default Login;
